"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useStyleOptions;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _botframeworkWebchatComponent = require("botframework-webchat-component");

function useStyleOptions() {
  var _hooks$useStyleOption = _botframeworkWebchatComponent.hooks.useStyleOptions(),
      _hooks$useStyleOption2 = (0, _slicedToArray2.default)(_hooks$useStyleOption, 1),
      styleOptions = _hooks$useStyleOption2[0];

  return [styleOptions];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTdHlsZU9wdGlvbnMudHMiXSwibmFtZXMiOlsidXNlU3R5bGVPcHRpb25zIiwiaG9va3MiLCJzdHlsZU9wdGlvbnMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUE7O0FBSWUsU0FBU0EsZUFBVCxHQUEyRDtBQUN4RSw4QkFBdUJDLG9DQUFNRCxlQUFOLEVBQXZCO0FBQUE7QUFBQSxNQUFPRSxZQUFQOztBQUVBLFNBQU8sQ0FBQ0EsWUFBRCxDQUFQO0FBQ0QiLCJzb3VyY2VSb290IjoiYnVuZGxlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGhvb2tzIH0gZnJvbSAnYm90ZnJhbWV3b3JrLXdlYmNoYXQtY29tcG9uZW50JztcblxuaW1wb3J0IHsgU3RyaWN0RnVsbEJ1bmRsZVN0eWxlT3B0aW9ucyB9IGZyb20gJy4uL3R5cGVzL0Z1bGxCdW5kbGVTdHlsZU9wdGlvbnMnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VTdHlsZU9wdGlvbnMoKTogW1N0cmljdEZ1bGxCdW5kbGVTdHlsZU9wdGlvbnNdIHtcbiAgY29uc3QgW3N0eWxlT3B0aW9uc10gPSBob29rcy51c2VTdHlsZU9wdGlvbnMoKTtcblxuICByZXR1cm4gW3N0eWxlT3B0aW9ucyBhcyBTdHJpY3RGdWxsQnVuZGxlU3R5bGVPcHRpb25zXTtcbn1cbiJdfQ==